module.exports = __webpack_public_path__ + "static/img/3_4_1.8ad688ad.jpg";